export const buttonCopyTranslationKeys = {
  tooltipCopied: 'tooltip.copied',
}
